module.exports = {"id":"231530","name":"José Arnáiz","rating":"74","photo":"./data/images/photos/2/231530.png","club":{"name":"FC Barcelone B","logo":"./data/images/clubs/FCBarceloneB.png"},"positions":["MG","BU","MD"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/JoseArnaiz0.json
// module id = 2164
// module chunks = 0